module.exports = __webpack_public_path__ + "src/app/_content/imgs/endOfTerm/download.png?c7b03da33a9949c8c3ab57bf9914ed7a";